import React from "react";
import TextInput from "../../../component/element/forms/TextInput";
import { useAppDispatch, useAppSelector } from "../../../store";
import { update_category } from "../../../services/apis/category";
import Modal from "../../../component/ui/modal";
import { ICategory } from "../../../store/types/category";

type IEditCategory = {
  category: ICategory;
  show: boolean;
  onHandler: () => void;
};

const EditCategory: React.FC<IEditCategory> = ({
  show,
  category,
  onHandler,
}) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ category }) => category.loading);
  const [data, dataSet] = React.useState<ICategory>({
    id: 0,
    name: "",
  });

  const onLoad = React.useCallback(() => {
    if (category.name && category.id) {
      const { name, id } = category;
      dataSet({ id, name });
    }
  }, [category]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <Modal
      title="Edit Category"
      open={show}
      onClose={onHandler}
      onOkClick={async () => {
        const updated = await update_category(dispatch, data.id, data.name);
        if (updated) onHandler();
      }}
      isLoading={loading}
    >
      <div className="mb-6">
        <TextInput
          label="Category Name"
          name="name"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dataSet((prev) => ({ ...prev, name: e.target.value }))
          }
          placeholder="Enter Category Name"
          type="text"
          value={data.name}
        />
      </div>
    </Modal>
  );
};

export default EditCategory;
